/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_FreshnessInputs */

const en_svchip_freshness = /** @type {(inputs: Svchip_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Freshness`)
};

const ar_svchip_freshness = /** @type {(inputs: Svchip_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الحداثة`)
};

const bn_svchip_freshness = /** @type {(inputs: Svchip_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ফ্রেশনেস`)
};

const de_svchip_freshness = /** @type {(inputs: Svchip_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frische`)
};

const es_svchip_freshness = /** @type {(inputs: Svchip_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frescura`)
};

const fr_svchip_freshness = /** @type {(inputs: Svchip_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fraîcheur`)
};

const pt_svchip_freshness = /** @type {(inputs: Svchip_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frescor`)
};

const zh_svchip_freshness = /** @type {(inputs: Svchip_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新鲜度`)
};

const tr_svchip_freshness = /** @type {(inputs: Svchip_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tazelik`)
};

const ru_svchip_freshness = /** @type {(inputs: Svchip_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Свежесть`)
};

const pl_svchip_freshness = /** @type {(inputs: Svchip_FreshnessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Świeżość`)
};

/**
* | output |
* | --- |
* | "Freshness" |
*
* @param {Svchip_FreshnessInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_freshness = /** @type {((inputs?: Svchip_FreshnessInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_FreshnessInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_freshness(inputs)
	if (locale === "bn") return bn_svchip_freshness(inputs)
	if (locale === "de") return de_svchip_freshness(inputs)
	if (locale === "es") return es_svchip_freshness(inputs)
	if (locale === "fr") return fr_svchip_freshness(inputs)
	if (locale === "pt") return pt_svchip_freshness(inputs)
	if (locale === "zh") return zh_svchip_freshness(inputs)
	if (locale === "tr") return tr_svchip_freshness(inputs)
	if (locale === "ru") return ru_svchip_freshness(inputs)
	if (locale === "pl") return pl_svchip_freshness(inputs)
	return en_svchip_freshness(inputs)
});